import '@angular/compiler';

import { enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, PreloadAllModules, withPreloading } from '@angular/router';
import { provideIonicAngular, IonicRouteStrategy } from '@ionic/angular/standalone';
import { RouteReuseStrategy } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { IonicStorageModule } from '@ionic/storage-angular';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

import { register } from 'swiper/element/bundle';
import { addIcons } from 'ionicons';
import { arrowBack, arrowDownOutline, arrowForward, camera, cashOutline, chatboxOutline, checkmarkCircleOutline, checkmarkOutline, closeCircleOutline, download, downloadOutline, eye, eyeOff, eyeOutline, heart, heartOutline, homeOutline, listOutline, logOut, personCircleOutline, radioButtonOff, radioButtonOffOutline, radioButtonOn, searchOutline, share, shareOutline, shareSocialOutline, statsChartOutline, timeOutline } from 'ionicons/icons';

register(); // 🔥 REQUIRED FOR SWIPER

if (environment.production) {
  enableProdMode();
}

addIcons({
  'search-outline': searchOutline,
  'radio-button-off':radioButtonOff,
  'radio-button-on':radioButtonOn,
  'home-outline': homeOutline,
  'back-button':arrowBack,
  'ios-arrow-down-outline':arrowDownOutline,
  'camera':camera,
  'ios-download':download,
  'ios-share':share,
  'custom-down':downloadOutline,
  'custom-share':shareOutline,
  'custom-name': '',
  'checkmark-circle-outline': checkmarkCircleOutline,
  'radio-button-off-outline':radioButtonOffOutline,
  'list-outline':listOutline,
  'close-outline':closeCircleOutline,
  'log-out-outline':logOut,
  'eye-off':eyeOff,
  'eye':eye,
  'heart':heart,
  'heart-outline':heartOutline,
  'share-social-outline': shareSocialOutline,
  'checkmark-circle':checkmarkCircleOutline,
  'time-outline':timeOutline,
  'arrow-forward':arrowForward,
  'eye-outline':eyeOutline,
  'person-circle-outline':personCircleOutline,
  'cash-outline':cashOutline,
  'stats-chart-outline':statsChartOutline,
  'chatbox-outline':chatboxOutline


});



bootstrapApplication(AppComponent, {
 providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch(err => console.error(err));
